var moment = require('moment-timezone')

module.exports.getDateFormatted = function getDateFormatted() {
    return moment().utc(true).tz("Asia/Beirut").format("MMM DD, YYYY hh:mm A")
}